import { Component, OnInit } from '@angular/core';
import { CustomerService } from 'src/app/services/customer.service';
import { Customer } from 'src/app/models/customer';
import { TravelRouteService } from 'src/app/services/travel-route.service';
import { TravelRoute } from 'src/app/models/travel-route';
import { ToastrManager } from 'ng6-toastr-notifications';
import { UtilitiesService } from 'src/app/services/utilities.service';

@Component({
  selector: 'app-route',
  templateUrl: './route.component.html',
  styleUrls: ['./route.component.css']
})
export class RouteComponent implements OnInit {
  customers:Customer[] = [];
  customer:Customer = {
    account_number: '',
    active: false,
    colony: '',
    comercial_name: '',
    directions: [],
    email: '',
    id: 0,
    locality: '',
    name: '',
    phone_number: '',
    rfc: '',
    state: '',
    street: '',
    type: '',
    zip_code: 0,
    contact: '',
    contact_email: '',
    
  };
  loading:boolean = false;
  routes:TravelRoute[] = [];

  constructor(private custServ:CustomerService, private routeServ:TravelRouteService, private toastr: ToastrManager, private utl: UtilitiesService) { }

  ngOnInit() {
    this.loading = true;
    this.custServ.getCustomers().then(customers => {
      this.customers = customers.filter(x => x.type != 'Compañia');
      this.customer = this.customers[0];
      this.loading = false;
    });
  }

  search() {
    this.loading = true;
    this.routeServ.getByCustomer(this.customer).then(routes => {
      this.routes = routes;
      this.loading = false;
    });
  }

  onEventLaunched($event) {
    this.toastr.successToastr($event, '', {enableHTML: true});
    this.search();
  }
}
